import { RefetchOptions, QueryObserverResult, UseMutationResult } from '@tanstack/react-query';
import { AiPromptForm } from './AiPromptForm';
import { User } from '@/types/TAccounts';
import { useState } from 'react';
import CopyableText from '@/components/LabelWithdescription/CopyableText';
import { formatTextWithHighlightedVariables } from '@/utils/textFormatting';
import { Button } from 'antd';
import { EditOutlined } from '@ant-design/icons';

export const AiPromptInfo: React.FC<{
	data: any;
	refetch: (options?: RefetchOptions) => Promise<QueryObserverResult<User, Error>>;
	mutation: UseMutationResult<unknown, Error, any, unknown>;
	isNoviUser?: boolean;
}> = ({ data, refetch, mutation, isNoviUser }) => {
	const aiPrompt = data?.ai_prompt || '';
	const [isEditing, setIsEditing] = useState(false);

	const handleUpdateComplete = () => {
		setIsEditing(false);
	};

	const InfoComponent = () => {
		return (
			<div className="mt-1 pt-2 pb-4">
				<span
					dangerouslySetInnerHTML={{
						__html: formatTextWithHighlightedVariables(aiPrompt.replace(/\n/g, '<br />')),
					}}
				/>
				<div className="mt-2">
					<CopyableText text={aiPrompt} hideText />
				</div>
			</div>
		);
	};

	return (
		<div className="relative">
			{isEditing ? (
				<AiPromptForm
					mutation={mutation}
					ai_prompt={aiPrompt}
					refetch={refetch}
					isNoviUser={isNoviUser}
					onCancel={handleUpdateComplete}
				/>
			) : (
				<InfoComponent />
			)}

			<div className="flex justify-end items-start mb-4">
				{!isEditing && (
					<Button
						icon={<EditOutlined />}
						onClick={() => setIsEditing(true)}
						className="border-blue-100 bg-blue-50 hover:bg-blue-100 hover:border-blue-200 text-blue-700"
						size="small"
					>
						Edit
					</Button>
				)}
			</div>
		</div>
	);
};
